import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
export const StyledLabel = styled.p`
  font-size: 13px;
  font-family: 'OpenSans-Regular' !important;
  color: #141414;
  margin: 10px;
`;
export const StyledDiv = styled.div`
  font-size: 13px;
  font-family: 'OpenSans-Regular' !important;
  color: #141414;
  margin: 16px 10px 8px 10px;
  opacity: 60%;
  height: 26px;
`;
export const StyledLabelGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 175px;
`;